<template>
  <template v-for="item in items" :key="item.label">
    <SbMenuSeparator v-if="item.separator" />
    <SbMenuGroup
      v-else-if="item.group && item.group.title"
      :title="item.group.title"
    >
      <SbMenuListItems :items="item.group.items" />
    </SbMenuGroup>
    <SbMenuItem v-else v-bind="item" />
  </template>
</template>

<script lang="ts" setup>
import SbMenuSeparator from './MenuSeparator.vue'
import SbMenuGroup from './MenuGroup.vue'
import SbMenuItem from './MenuItem.vue'
import SbMenuListItems from './MenuListItems.vue'
import type { MenuItem } from './types'

defineProps<{
  items: MenuItem[]
}>()
</script>
